import { type RecommendationContext } from '@atlassian/post-office-context/message-lifecycle';

export enum InAppMessageEventType {
	Viewed = 'viewed',
	Acknowledged = 'acknowledged',
	Clicked = 'clicked',
	ClickedSecondary = 'clickedSecondary',
	Dismissed = 'dismissed',
	Snoozed = 'snoozed',
	Read = 'read',
	Unread = 'unread',
}

export type PostOfficeContext = {
	orgId?: string;
	subproduct?: string;
	tenantId?: string;
	isSiteAdmin?: boolean;
	workspaceId?: string;
	locale: string | undefined;
	product: string | undefined;
};

export interface MessageEventPostPayload {
	messageTemplateId: string;
	messageInstanceId: string;
	transactionAccountId?: string;
	placement: string;
	type: InAppMessageEventType;
	context: {
		recommendation: RecommendationContext;
		browser: PostOfficeContext;
	};
	analyticsDetails?: Record<string, string | number | boolean>;
	createdAt: number;
	statusExpiryTime?: number;
}
